<template>
  <v-form @submit.prevent ref="form" v-model="valid">
    {{ valid }}
    <functionality-form :doc="doc" :tags="tags" />
    <v-btn class="mt-5 amber" @click="onSubmit">Submit</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import FunctionalityForm from "./FunctionalityForm";
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");

export default {
  name: "UserFunctionalityFormAdd",
  components: {
    FunctionalityForm,
  },
  props: {
    doc: {
      type: Object,
      default: () => {},
    },
    tags: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      valid: true,
    };
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.validate();
      if (this.valid) {
        let ref = fb.functionalityBetaCollection.doc();
        ref
          .set({
            createdOn: new Date(),
            id: ref.id,
            uid: this.currentUser.uid,
            ...this.doc,
            pid: this.currentProjectModel.id,
          })
          .then(() => {
            this.$emit("close");
          })
          .catch((error) => {
            alert("Error adding document: ", error);
          });
      }
    },
    populateField(field) {
      return field ? field : null;
    },
    validate() {
      this.$refs.form.validate();
    },
  },
};
</script>
